import {Carousel} from "./carousel.js";
import {CarouselItem} from "./item.js";


// Define the new element
if(customElements.get('carousel-cell') || customElements.get('carousel-root')) console.warn("Carousel elements had already been defined");
$(()=>{
    customElements.define("carousel-root", Carousel);
    customElements.define("carousel-cell", CarouselItem);
})
export {};